var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-row',{staticClass:"page-wrapper",attrs:{"justify":"center"}},[_c('indications-history-search-form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }